import 'uni-pages';import 'uni-h5';import Vue from "vue";
import App from "./App";




Vue.config.productionTip = false;

App.mpType = "app";

// 引入全局uView
import uView from "uview-ui";
Vue.use(uView);
// 引入vuex
import stores from "./store/home";
Vue.prototype.$stores = stores;

import store from "./store/index.js";
Vue.prototype.$store = store;

import chat from "./store/chat.js";
Vue.prototype.$chat = chat;

const app = new Vue({
  ...App,
  store,
});

import config from "@/common/config/config.js";

Vue.prototype.staticHost = config.staticHost;
Vue.prototype.$staticHost = config.staticHost;

if (process.env.NODE_ENV === "development") {
  Vue.prototype.host = config.devHost;
  Vue.prototype.$websocketHost = config.devWebsocketHost;
} else {

  let host = window.location.host;
  Vue.prototype.host = `${window.location.protocol}//${host}`;







  Vue.prototype.$websocketHost = "wss://" + host + "/wss";
  // Vue.prototype.$websocketHost = 'wss://xlketang.cn/wss'

  // Vue.prototype.host = config.host
  // Vue.prototype.$websocketHost = config.websocketHost

  Vue.prototype.$staticHost = Vue.prototype.host;
}

import httpInterceptor from "@/common/api/http.interceptor.js";
Vue.use(httpInterceptor, app);

import httpApi from "@/common/api/api.js";
Vue.use(httpApi, app);

import helper from "@/common/helper/helper.js";
Vue.prototype.helper = helper;

Vue.prototype.showMsg = function (msg) {
  uni.showToast({ title: msg, icon: "none", mask: true });
};
Vue.prototype.WaitTo = function (resolve) {
  setTimeout(function () {
    resolve();
  }, 1000);
};

Vue.prototype.sendSocketMessage = function (msg) {
  let _this = this;
  if (App.globalData.socketOpen) {
    if (typeof msg == "object") {
      msg = JSON.stringify(msg);
    }

    return new Promise(function (resolve, reject) {
      uni.sendSocketMessage({
        data: msg,
        success: function (res) {
          resolve();
        },
        fail: function (err) {
          _this.showMsg("消息发送失败");
          console.log(err);
          reject();
        },
      });
    });
  } else {
    this.showMsg("聊天组件未准备好");
  }
};

let mpShare = require("uview-ui/libs/mixin/mpShare.js");
Vue.mixin(mpShare);

Vue.prototype.$onLaunched = new Promise((resolve) => {
  Vue.prototype.$isResolve = resolve;
});

Vue.prototype.$globalData = function () {
  return app.globalData;
};

Vue.prototype.$beforOnLoad = function () {
  return new Promise(async (resolve) => {
    try {
      await app.init_weixin();
    } catch (e) {
      //TODO handle the exception
    }

    resolve();
  });
};

Vue.prototype.$beforOnShow = function () {
  return new Promise((resolve) => {
    app.navTitle();
    // app.init_weixin()
    resolve();
  });
};

Vue.prototype.user = function () {
  let user = uni.getStorageSync("user");
  if (!user) {
    uni.setStorageSync("token", "");
    uni.setStorageSync("user", "");
  }
  return user;
};

Vue.prototype.checkToken = function () {
  let token = uni.getStorageSync("token");
  if (!token) {
    return false;
  } else {
    this.$u.api.checkToken({}).then((res) => {
      if (res.code == 0) {
        uni.setStorageSync("token", "");
        uni.setStorageSync("user", "");
        return false;
      } else {
        return true;
      }
    });
  }
};

Vue.prototype.getUser = function () {
  return new Promise(function (resolve, reject) {
    app.$u.api.userInfo({}).then((res) => {
      if (res.code) {
        // console.log(uni.getStorageSync('user'))
        uni.setStorageSync("info", res.data);
        uni.setStorageSync("user", res.data);
        // uni.setStorageSync("token", res.data.access_token)
        // uni.setStorageSync("token", res.data.token)
        console.log(uni.getStorageSync("user"));
        resolve(res.data);
      }
    });
  });
};

Vue.prototype.is_gzh = function () {



  let ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  }
  return false;
};

Vue.prototype.mini_login = function (r_data = {}) {
  return new Promise(function (resolve, reject) {
    uni.login({
      success: function (loginRes) {
        console.log(r_data);
        console.log(loginRes);
        let code = loginRes.code;
        r_data.code = code;
        app.$u.api.miniLogin(r_data).then((res) => {
          if (res.code == 1) {
            uni.setStorageSync("third_key", "");
            uni.setStorageSync("user", res.data);
            uni.setStorageSync("token", res.data.access_token);
            // uni.setStorageSync("token",res.data.token)
            resolve(res);
          } else {
            uni.setStorageSync("third_key", res.data.third_key);
            resolve(res);
          }
        });
      },
    });
  });
};

app.$mount();